import React from 'react';
import { ReactComponent as SwapIcon } from 'Icons/swap.svg';

const CurrencyConversionDetails = (props) => {
    const { currencyDetails, currencyTypes } = props;
    const inrData = ((currencyTypes || []).find(cType => cType.currency_name === 'INR') || {});
    return (
        <table className={'mt-10 mb-5 fs-12'}>
            {(currencyDetails || []).filter(currency => ((currency.name || '').split(' ')[0] == 'USD')).map((el, index) => {
                // const currencySymbol = ((currencyTypes || []).find(cType => cType.currency_name === el.name.split(' ')[0]) || {});
            return(
            <tr className={'fs-14 flex flex-middle'} key={index}>
                <td>1 {el.name.split(' ')[0]}</td>
                <td> <SwapIcon className='wt-20 ht-20 ml-5 mr-5'/>
                </td>
                <td className={'flex flex-middle fs-14'}>{inrData.currency_symbol} {el.rupee}</td>
            </tr>)})}
        </table>
    )
}

export default CurrencyConversionDetails;